import Base from "../../../class/Base"

/**
 * Represent an entity. An entity must have an unique id.
 */
export default class Entity extends Base {}
Entity.addProperties({
	id : null, // an id can be a number or string
});
